module.exports = __webpack_public_path__ + "img/shoot_00020.85204145.png";